<template>
  <v-form
    ref="form"
    lazy-validation
    class="form-box formStyle">
    <v-text-field
      v-model="categoryName"
      class="mb-6"
      :rules="categoryNameRules"
      :label="$t('adhibition.appGroup.groupName')"
      outlined
      required
      dense
    ></v-text-field>
    <v-row no-gutters>
      <v-col cols="12" class="mb-2">
        <v-btn color="primary" @click="onSubmit" small>{{$t('btn.submit')}}</v-btn>
        <v-btn class="close_btn" outlined @click="closeModel" small>{{$t('btn.close')}}</v-btn>
      </v-col>
    </v-row>

  </v-form>

</template>
<script>

  import { reqAddProductGroup,reqUpdGroupName} from "@/api/index";
  import store from '@/store'
  export default {
    name:'category',
    props:{
      componentData:{
        type:Object,
        default:()=>null
      }

    },
    data() {
      return {
        categoryNameRules: [
          v => !!v || this.$t('adhibition.appGroup.requireGroupName'),
          v => (v && v.length <= 20) || this.$t('adhibition.appGroup.maxGroupName'),
        ],
        categoryName: '',


      }

    },

    created() {
      if(this.componentData){
        this.categoryName =  this.componentData.groupName
      } else {
        this.categoryName = ""
      }
      console.log("created",this.componentData)
    },
    methods:{
      closeModel(){
        this.$emit('close')
      },
      onSubmit () {
        if(this.$refs.form.validate()){
          if(this.componentData){
            reqUpdGroupName({
              groupName:this.categoryName,
              id:this.componentData.id
            }).then(res=>{
              if(res.code == 200) {
                store.dispatch('snackbar/openSnackbar',{
                  snackbarText: res.message,
                  colorType:'success'
                })
              }else{
                store.dispatch('snackbar/openSnackbar',{
                  snackbarText: res.message,
                  colorType:'error'
                })
              }
              this.$emit('success')
            })

          }else{
              reqAddProductGroup({
                groupName:this.categoryName,
                type:1
              }).then(res=>{
                if(res.code == 200) {
                  store.dispatch('snackbar/openSnackbar',{
                    snackbarText: res.message,
                    colorType:'success'
                  })
                }else{
                  store.dispatch('snackbar/openSnackbar',{
                    snackbarText: res.message,
                    colorType:'error'
                  })
                }
                this.$emit('success')
              })
          }
        }
      },
    }

  }


  </script>

<style lang='scss' scoped>

  .formStyle{
    width: 70%;
    margin-left: 15%;
  }
  .close_btn{
    margin-left: 10px;
  }

</style>
